module.exports = __webpack_public_path__ + "static/media/popup_loading.abae73bb.svg";